// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js';

console.log('--- supabaseClient.js EXECUTING ---');

const supabaseUrlFromEnv = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKeyFromEnv = process.env.REACT_APP_SUPABASE_ANON_KEY;

console.log('[SupabaseClient] Raw process.env.REACT_APP_SUPABASE_URL:', supabaseUrlFromEnv);
console.log('[SupabaseClient] Raw process.env.REACT_APP_SUPABASE_ANON_KEY:', supabaseAnonKeyFromEnv); // THIS IS THE MOST IMPORTANT LOG

if (!supabaseUrlFromEnv || !supabaseAnonKeyFromEnv) {
  console.error(
    "CRITICAL: Supabase URL or Anon Key is UNDEFINED in supabaseClient.js. Ensure .env is correct and dev server was RESTARTED."
  );
   // To make it absolutely obvious if this is the case:
   // alert("Supabase ENV VARS MISSING! Check console and .env then restart server.");
}

export const supabase = createClient(supabaseUrlFromEnv, supabaseAnonKeyFromEnv);
console.log('[SupabaseClient] Supabase client instance created.');